import { createFileRoute } from "@tanstack/react-router";
import { mcpConnectionDonePageRoute } from "@/features/mcp-connections";

export const Route = createFileRoute("/kits/connect/done")({
    ...mcpConnectionDonePageRoute,
});
